import { AccessAction } from '@common/entities';
import { AppProjectClone, useAppProjectAbility } from '@common/hooks';
import { VisitorStatsTable } from '@pages/Analytics/AppAnalytics/components';
import { useCurrentApp } from '@pages/AppDetails/hooks';

export default function Analytics() {
    const ability = useAppProjectAbility();
    const { app } = useCurrentApp();

    if (!ability?.can?.(AccessAction.MANAGE, new AppProjectClone(app) as any)) return null;

    return <VisitorStatsTable id={app?._id} />;
}
